<div class="flex flex-column align-items-center justify-content-between p-4 standard-bigger-max-width">
    <!-- Confirmation Dialog Host -->
    <p-confirmDialog [style]="{maxWidth: '600px'}"></p-confirmDialog>
    <div class="mb-4 w-full flex flex-column justify-content-start align-items-start">
        <div>
            <h3>
                <i class="pi pi-calendar mr-2 text-blue-500 text-2xl"></i>
                Measurement Date
            </h3>
            <p>To add <b>historic data</b>, simply select a date in the past.</p>
        </div>

        <div class="grid formgrid" [formGroup]="getFormChild('visitData')!">
            <p-calendar formControlName="date" [inline]="false" [showWeek]="false" [showIcon]="true">
            </p-calendar>
        </div>
    </div>

    <div [formGroup]="getFormChild('visitData')!">
        <h3 class="w-full">
            <i class="pi pi-eye mr-2 text-blue-500 text-2xl"></i>
            Eye Measurements
        </h3>
        <div class="w-full flex flex-row justify-content-between align-items-center mb-8">
            <div class="mr-2">
                <app-crud-eye-measurement [eyeSide]="Eye.RIGHT" [form]="getFormChild('rightEye')!" />
            </div>
            <div class="">
                <app-crud-eye-measurement [eyeSide]="Eye.LEFT" [form]="getFormChild('leftEye')!" />
            </div>
        </div>

        <div class="w-full flex justify-content-center mb-2"
            *ngIf="uiState.form.hasError('atLeastOneEyeRequired') && uiState.form.touched">
            <div class="p-3 border-round bg-red-50 border-1 border-red-200 w-full text-center">
                <p class="text-red-600 font-medium m-0">
                    <i class="pi pi-exclamation-triangle mr-2"></i>
                    At least one eye must have a Sphere value.
                </p>
            </div>
        </div>

        <button class="w-full mb-2" pButton icon="pi pi-plus" label="Add Visit for Patient and Calculate PreMO"
            (click)="onSubmit(true)" [disabled]="uiState.form.invalid">
        </button>

        <button class="w-full p-button-outlined" pButton icon="pi pi-plus" label="Add Visit" (click)="onSubmit(false)"
            [disabled]="uiState.form.invalid">
        </button>
    </div>
</div>